import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { useState } from 'preact/hooks'
import { defaultConfig, sortOptions } from '../config'

export default () => {
    const { loading, query, response, response: { products: { facets } } = {} } = useAppState()
    const { updateSearch } = useActions()
    const [active, setActive] = useState(false)
    const activeSort =
        sortOptions.find((option) =>
            option.value.sort.every((v1) =>
                query.products?.sort?.find((v2) => v1.field === v2.field && v1.order === v2.order)
            )
        )?.id ?? defaultConfig.sort.id

    return (
        <li class={`ns-sidebar-dropdown ${active ? 'ns-active' : ''}`}>
            <a
                class="nosto-sorting-mobile nosto-sidebar-dropdown ns-d-flex ns-justify-content-between ns-align-content-center ns-relative ns-w-100 ns-border-box ns-text-undecorated"
                href="javascript:void(0)"
                onClick={() => {
                    setActive(!active)
                }}>
                <span>
                    Sort: <span>{sortOptions.find((o) => o.id === activeSort)?.value.name}</span>
                </span>
                {active ? (
                    // Minus
                    <svg
                        width="16"
                        height="2"
                        viewBox="0 0 16 2"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1 1H15"
                            stroke="#3C3C3C"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                ) : (
                    // Plus
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8 1V15M1 8H15"
                            stroke="#3C3C3C"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                )}
            </a>
            <div class="ns-sidebar-submenu ns-d-none ns-pt-4">
                <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                    {sortOptions.map((o) => (
                        <li
                            class="ns-mobile-facet-filter ns-d-flex ns-justify-content-between ns-align-items-center ns-font-3"
                            key={o.id}>
                            <label class="ns-checkbox ns-d-block ns-color-grey-dark">
                                {o.value.name}
                                <input
                                    type="radio"
                                    value={o.id}
                                    checked={activeSort === o.id}
                                    onChange={(e) => {
                                        updateSearch({
                                            products: {
                                                sort: sortOptions.find((v) => v.id === e.target.value)?.value
                                                    ?.sort,
                                            },
                                        })
                                    }}
                                />
                                <span class="ns-checkmark-mobile"></span>
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        </li>
    )
}

{
    /* <div class="ns-sorting nosto-dropdown-container">
<span>Sort By: </span>
<select
    name="ns-sort-dropdown"
    id="ns-sort-dropdown"
    class="ns-selection-dropdown-menu-mobile ns-text-align-left"
    value={activeSort}
    onChange={(e) => {
        updateSearch({
            products: {
                sort: sortOptions.find((v) => v.id === e?.target?.value)?.value?.sort,
            },
        })
    }}>
    {sortOptions.map((o) => (
        <option value={o.id}>{o.value.name}</option>
    ))}
</select>
</div> */
}
